// extracted by mini-css-extract-plugin
export default {"disabled":"ClientMultiSelect_disabled__IqIQ8"};